
import { Vue, Component, Prop } from "vue-property-decorator"
import SelectRelatedArticle from "@/components/SelectRelatedArticle.vue"
import { mapState } from "vuex"
import { RelatedArticle } from "types/index"
import { DataTableHeader } from "vuetify/types"
import { ArticleState } from "src/store/articleType"

@Component({
  components: { SelectRelatedArticle },
  computed: {
    ...mapState("article", {
      relatedArticles: (state) => (state as ArticleState).relatedArticles,
    }),
  },
})
export default class RelatedArticles extends Vue {
  @Prop()
  private readonly!: boolean

  private showDialog = false
  private pagination = {
    sortBy: ["id"],
    sortDesc: [true],
    itemsPerPage: -1,
  }
  private relatedArticles!: RelatedArticle[]

  get headers(): DataTableHeader[] {
    return [
      { text: "ID", value: "id" },
      { text: "タイトル", value: "title" },
      { text: "コンシェルジュ", value: "writer" },
      { text: "操作", value: "action", sortable: false },
    ]
  }

  public show(): void {
    this.showDialog = true
  }

  public hide(): void {
    this.showDialog = false
    const selectRelatedArticle = this.$refs
      .selectRelatedArticle as InstanceType<typeof SelectRelatedArticle>
    selectRelatedArticle.clear()
  }

  public async ok(articles: RelatedArticle[]): Promise<void> {
    if (articles.length > 0) {
      const oldArticles = Array.from(this.relatedArticles)
      const newArticles = oldArticles.concat(articles)

      await this.$store
        .dispatch("article/updateArticle", { relatedArticles: newArticles })
        .catch(() => {
          this.hide()
          return
        })
    }
    this.hide()
  }

  public cancel(): void {
    this.hide()
  }

  public async remove(id: number): Promise<void> {
    const articles = Array.from(this.relatedArticles)
    const index = articles.findIndex((obj) => {
      return obj.id === id
    })
    articles.splice(index, 1)
    await this.$store.dispatch("article/updateArticle", {
      relatedArticles: articles,
    })
  }
}
